<template>
  <div class="user-search-machine">
    <vtm-filter-bar
      v-if="!isRenewal"
      ref="fb"
      :fields="fields"
      :search="search"
      :extra-keys="['rentState', 'faultStatus', 'enableStatus', 'sort', 'order']"
      storage-key="machines"
      @submit="onSubmit"
      @reset="resetSearch"
    >
      <template #lead>
        <el-button
          size="small"
          v-hasPerm="['user:machine:export']"
          icon="el-icon-receiving"
          @click="exportUserMachine"
          >{{ $t("common.export") }}</el-button
        >
        <el-button
          size="small"
          v-hasPerm="['renewal:record:insert']"
          type="warning"
          icon="el-icon-goods"
          :disabled="selectList.length <= 0"
          @click="batchRenewal"
          >{{ $t("searchUserMachine.renew") }}</el-button
        >
        <!-- 回收 -->
        <el-button
          type="danger"
          v-hasPerm="['machine:user:recover']"
          size="small"
          icon="el-icon-delete"
          :disabled="selectList.length <= 0"
          @click="recoverMachine"
          >{{ $t("searchMachine.recover") }}</el-button
        >
      </template>

      <!-- 尾部插槽：列设置等 -->
      <template #trail>
        <slot name="trail"></slot>
      </template>
    </vtm-filter-bar>

    <!-- 立即续费进来的 -->
    <div v-else style="padding: 15px; display: flow-root">
      <div style="float: left; line-height: 32px; height: 32px; font-size: 15px">
        <el-button
          size="small"
          v-hasPerm="['user:machine:export']"
          icon="el-icon-magic-stick"
          @click="handlerBackAll"
          style="margin-right: 5px"
          >{{ $t("common.backAll") }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
  import VtmFilterBar from "@/components/common/VtmFilterBar";

  export default {
    name: "SearchUserMachine",
    components: { VtmFilterBar },
    props: {
      search: Object,
      selectList: Array,
      yesNo: Array,
      appTypeList: Array,
      machineType: Array,
      machineGroup: Array,
      rentStateList: Array,
      isRenewal: Boolean
    },
    computed: {
      // 可叠加检索的字段（映射到后端 userEquipment/page 参数）
      fields() {
        return [
          { value: "equipmentName", label: this.$t("searchOrder.equipmentName"), list: "equipmentNameList" },
          { value: "equipmentNo", label: this.$t("searchUserMachine.equipmentNo"), list: "equipmentNoList" },
          { value: "userName", label: this.$t("searchUserMachine.userName") }
        ];
      }
    },
    methods: {
      recoverMachine() {
        this.$emit("recoverMachine");
      },
      exportUserMachine() {
        // 导出与列表同条件（含所有生效标签）
        if (this.$refs.fb) this.$refs.fb.syncFilters();
        this.$confirm(this.$t("searchUserMachine.export"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            this.$api.download(this.$url.UserMachine.export, this.search);
          })
          .catch(err => {
            this.$message.error(err.msg);
          });
      },
      batchRenewal() {
        if (this.selectList.length <= 0) {
          this.$message.warning(this.$t("searchUserMachine.check"));
        } else {
          this.$emit("batchRenewal");
        }
      },
      onSubmit() {
        this.$emit("onSubmit", this.search);
      },
      handlerBackAll() {
        this.$emit("handlerBackAll");
      },
      resetSearch() {
        this.$toolUtil.clearForm(this.search);
        this.$emit("resetSearch", this.search);
      }
    }
  };
</script>
